import api from "../../../api/axios";

// DEALS-PRIVATE-FINANCE-B1 — owner-private finance transport.
// Nested endpoints are party-scoped by the backend; never source this data
// from shared Deal list/detail payloads.

export const fetchDealMyFinance = (dealId, { signal } = {}) =>
  api
    .get(`/realty/deals/${dealId}/my-finance/`, { signal })
    .then((res) => res.data);

export const patchDealMyFinance = (dealId, payload, { signal } = {}) =>
  api
    .patch(`/realty/deals/${dealId}/my-finance/`, payload, { signal })
    .then((res) => res.data);

export const fetchDealMyFinancePayments = (dealId, { signal } = {}) =>
  api
    .get(`/realty/deals/${dealId}/my-finance/payments/`, { signal })
    .then((res) => res.data);

export const createDealMyFinancePayment = (dealId, payload, { signal } = {}) =>
  api
    .post(`/realty/deals/${dealId}/my-finance/payments/`, payload, { signal })
    .then((res) => res.data);

export const patchDealMyFinancePayment = (
  dealId,
  paymentId,
  payload,
  { signal } = {},
) =>
  api
    .patch(
      `/realty/deals/${dealId}/my-finance/payments/${paymentId}/`,
      payload,
      { signal },
    )
    .then((res) => res.data);

export const deleteDealMyFinancePayment = (
  dealId,
  paymentId,
  { signal } = {},
) =>
  api
    .delete(`/realty/deals/${dealId}/my-finance/payments/${paymentId}/`, {
      signal,
    })
    .then((res) => res.data);
